import HttpClient from "../services/HttpClient";
import {
  APP_URL,
  POSTULATESTATUS,
  APPLICATIONSTAGE,
  APPLICATION_STAGE_RESULT_LIST,
  START_SELECTION_PROCESS,
  ERROR_MESSAGE,
  APPLICATIONSTAGE_BY_POSTULATE
} from "../constants";

export const getPostulateStatus = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${POSTULATESTATUS}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getApplicationStage = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${APPLICATIONSTAGE}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getApplicationStageByPostulate = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${APPLICATIONSTAGE_BY_POSTULATE}${id}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};



export const getApplicationStageResultList = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${APPLICATION_STAGE_RESULT_LIST}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const startSelectionProcess = (selectionProcess, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL}${START_SELECTION_PROCESS}`,
      selectionProcess,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};
